/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 16,
    height: 16,
    viewBox: '0 0 26 32',
    data: '<path pid="0" d="M19.2 32c.54 0 1.02-.19 1.42-.56.4-.38.63-.83.67-1.37l2.34-23.08H25c.27 0 .5-.1.7-.3.2-.2.3-.43.3-.7 0-.27-.1-.5-.3-.7a.96.96 0 00-.7-.3h-7V2.28c0-.65-.23-1.19-.69-1.63A2.3 2.3 0 0015.69 0h-5.36C9.7 0 9.16.22 8.7.65c-.46.45-.7.98-.7 1.63v2.71H1c-.27 0-.5.1-.7.3-.2.2-.3.43-.3.7 0 .27.1.5.3.7.2.2.43.3.7.3h1.37l2.3 23.08c.07.54.3 1 .7 1.37.41.37.89.56 1.43.56h12.4zM16 4.99h-6V2.28a.3.3 0 01.1-.22.3.3 0 01.22-.1h5.36a.3.3 0 01.22.1c.06.06.1.13.1.22v2.71zM19.2 30H6.8c-.02 0-.05-.01-.08-.04s-.05-.06-.05-.08L4.4 6.98h17.2l-2.27 22.9a.1.1 0 01-.05.1.15.15 0 01-.08.02z"/>'
  }
})
